/**
 * @type { <T extends any[], R>(fn1: (arg: T) => R, ...fns: Array<(arg: R) => R>) => (...args: T) => R }
 */
const pipe = (...functions) => (
    args => functions.reduce((arg, fn) => fn(arg), args)
);

export default pipe;
